{
    "pxPerUnit": 150,
    "runtime": {
        "commandFrameMs": 33.333333333333336,
        "preloadSyncTimeoutMs": 0,
        "matchReadySyncTimeoutMs": 0,
        "navCollClampsToNavMesh": false
    },
    "presentation": {
        "localPlayerBot": {
            "showShadow": true,
            "showDirectionRing": true
        }
    },
    "combat": {
        "armorDmgScale": {
            "perPointOfArmor": 1,
            "minPercIncoming": -0.25,
            "maxPercIncoming": 0.75
        },
        "coolDownReductionMax": 0.95,
        "matchDurationTimeMax": 900000,
        "cooldownTimeInMs": 3600,
        "maxCooldownTimeInMs": 20000,
        "teleportToBaseActivationDurationInMs": 400000,
        "defaultTargetPriorityOrder": ["RamFollower"],
        "playerRespawnInvulnerabilityTime": 0
    }
}
